export default __webpack_public_path__ + "static/media/how-it-work.ae7d2e2d.svg";